module.exports = __webpack_public_path__ + "img/slider-11.2a130028.jpg";